import { addDays } from 'date-fns';
import { ClientTimelineType, ClientDurationUnit, } from '../../types';
import { serverDateToClientDate } from './date';
import { dateToLocalDateString } from '../../helpers/date';
import { DurationUnit, } from '@wix/ambassador-challenges-v1-challenge/types';
export const serverTimelineTypeToClientTimelineType = (serverTimeLineType) => {
    const typesMap = {
        ongoing: ClientTimelineType.Ongoing,
        flexible: ClientTimelineType.Flexible,
        specific: ClientTimelineType.Specific,
        // selfPaced: ClientTimelineType.SelfPaced, looks like it isn't relevant here, but maybe will be needed later
    };
    return typesMap[Object.keys(serverTimeLineType)[0]];
};
export const serverTimelineTypeToClientOngoingStartDate = (serverTimeLineType) => {
    return serverTimeLineType.ongoing
        ? serverDateToClientDate(serverTimeLineType.ongoing.startTime)
        : null;
};
export const serverTimelineTypeToClientFlexibleDuration = (serverTimeLineType) => {
    return serverTimeLineType.flexible
        ? serverTimeLineType.flexible.duration.value.toString()
        : '';
};
export const serverToClientDurationUnit = (duration) => {
    const durationUnitMap = {
        [DurationUnit.DAYS]: ClientDurationUnit.DAYS,
        [DurationUnit.WEEKS]: ClientDurationUnit.WEEKS,
    };
    return durationUnitMap[duration === null || duration === void 0 ? void 0 : duration.unit] || ClientDurationUnit.DAYS;
};
export const serverTimelineTypeToClientFlexibleDurationUnit = (serverTimeLineType) => {
    const flexible = serverTimeLineType.flexible;
    if (!flexible) {
        return ClientDurationUnit.DAYS;
    }
    return serverToClientDurationUnit(flexible.duration);
};
export const serverTimelineTypeToClientSpecificStartDate = (serverTimeLineType) => {
    return serverTimeLineType.specific
        ? serverDateToClientDate(serverTimeLineType.specific.startTime)
        : null;
};
export const serverTimelineTypeToClientSpecificEndDate = (serverTimeLineType) => {
    if (!serverTimeLineType.specific) {
        return null;
    }
    const { startTime: { year, month, day }, duration: { unit, value }, } = serverTimeLineType.specific;
    if (unit === DurationUnit.DAYS) {
        return addDays(serverDateToClientDate({ year, month, day }), Number(value) - 1); // -1 because last date included
    }
    return new Date(year, month - 1, Number(day) + Number(value) * 7 - 1, // -1 because last date included
    0, 0, 0, 0);
};
export const serverTimelineTypeToClientTimelineString = (serverTimelineType, locale, t, ongoingKey, flexibleDaysKey, flexibleWeeksKey, noLimitKey) => {
    var _a, _b;
    const type = Object.keys(serverTimelineType)[0];
    switch (type) {
        case 'ongoing':
            return t(ongoingKey, {
                date: dateToLocalDateString(serverTimelineTypeToClientOngoingStartDate(serverTimelineType), locale),
            });
        case 'flexible':
        case 'selfPaced':
            const duration = ((_a = serverTimelineType === null || serverTimelineType === void 0 ? void 0 : serverTimelineType.flexible) === null || _a === void 0 ? void 0 : _a.duration) ||
                ((_b = serverTimelineType === null || serverTimelineType === void 0 ? void 0 : serverTimelineType.selfPaced) === null || _b === void 0 ? void 0 : _b.duration); // duration is relevant only for flexible or self-paced here
            const count = (duration === null || duration === void 0 ? void 0 : duration.value) ? String(duration === null || duration === void 0 ? void 0 : duration.value) : null;
            return count
                ? (duration === null || duration === void 0 ? void 0 : duration.unit) === DurationUnit.DAYS
                    ? t(flexibleDaysKey, { count })
                    : t(flexibleWeeksKey, { count })
                : noLimitKey
                    ? t(noLimitKey)
                    : '';
        case 'specific':
            return `${dateToLocalDateString(serverTimelineTypeToClientSpecificStartDate(serverTimelineType), locale)} - ${dateToLocalDateString(serverTimelineTypeToClientSpecificEndDate(serverTimelineType), locale)}`;
        default:
            return '';
    }
};
//# sourceMappingURL=timelineType.js.map